import { render, staticRenderFns } from "./Reset-Password.vue?vue&type=template&id=08b6e79f"
import script from "./Reset-Password.vue?vue&type=script&lang=js"
export * from "./Reset-Password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports